import styled from 'styled-components';
import { Button, Input } from 'react-rainbow-components';

export const StyledButton = styled(Button)`
    width: 100%;
    margin-top: 16px;
`;

export const StyledInput = styled(Input)`
    margin-bottom: 12px;
`;
